import { Button } from "@/components/ui/button"
import { ArrowLeft, ArrowRight, CheckCircle } from "lucide-react"

interface FormNavigationProps {
  currentStep: number
  totalSteps: number
  isSubmitting: boolean
  isStepValid: boolean
  onPrevious: () => void
  onNext: () => void
  onSubmit: () => void
}

export function FormNavigation({
  currentStep,
  totalSteps,
  isSubmitting,
  isStepValid,
  onPrevious,
  onNext,
  onSubmit
}: FormNavigationProps) {
  const isLastStep = currentStep === totalSteps - 1

  return (
    <div className="flex justify-between items-center pt-8">
      <Button
        type="button"
        variant="outline"
        onClick={onPrevious}
        disabled={currentStep === 0}
        className="px-6 py-3 rounded-xl border-2 disabled:opacity-50 transition-transform hover:scale-105 active:scale-95"
      >
        <ArrowLeft size={18} className="mr-2" />
        Previous
      </Button>

      <div className="text-center">
        <div className="text-sm text-muted-foreground">
          Step {currentStep + 1} of {totalSteps}
        </div>
      </div>

      {isLastStep ? (
        <Button
          type="button"
          disabled={isSubmitting}
          onClick={onSubmit}
          className="bg-gradient-to-r from-[#FF7A00] to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-8 py-3 rounded-xl shadow-lg transition-transform hover:scale-105 active:scale-95"
        >
          {isSubmitting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2" />
              Submitting...
            </>
          ) : (
            <>
              Submit Quote
              <CheckCircle size={18} className="ml-2" />
            </>
          )}
        </Button>
      ) : (
        <Button
          type="button"
          onClick={onNext}
          disabled={!isStepValid}
          className="bg-gradient-to-r from-[#FF7A00] to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-6 py-3 rounded-xl shadow-lg disabled:opacity-50 transition-transform hover:scale-105 active:scale-95"
        >
          Next
          <ArrowRight size={18} className="ml-2" />
        </Button>
      )}
    </div>
  )
}
